// eslint-disable-next-line import/prefer-default-export
export const addCustomProperties = (contacts) =>
  contacts?.map((contact) => ({
    ...contact,
    fullName: contact.name,
  }))
